import { render } from "./ManuscriptSingle.vue?vue&type=template&id=093306eb&ts=true"
import script from "./ManuscriptSingle.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSingle.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__